<template>
  <!-- Web upload modal for all services -->
  <button
    type="button"
    :class="buttonClass"
    @click="$emit('click')"
  >
    <i :class="['bi', icon, 'me-1']"></i>
    <slot>{{ $t('menu.upload_file') }}</slot>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UploadButton',

  props: {
    // Custom button class (default: btn btn-primary)
    btnClass: {
      type: String,
      default: 'btn btn-primary'
    },
    // Additional classes
    extraClass: {
      type: String,
      default: ''
    },
    // Иконка кнопки: файл — плюс, ссылка — звено цепи
    icon: {
      type: String,
      default: 'bi-plus-lg'
    }
  },

  emits: ['click'],

  computed: {
    ...mapGetters('app', ['configData']),

    buttonClass() {
      return `${this.btnClass} ${this.extraClass}`.trim();
    }
  }
};
</script>
